document.addEventListener('DOMContentLoaded', function () {
  var trigger = document.getElementById('open-featured-form');
  if (!trigger) return;

  var modal = document.getElementById('featured-form-modal');
  var closeBtn = modal.querySelector('.featured-form-close');
  var overlay = modal.querySelector('.featured-form-overlay');
  var container = document.getElementById('featured-form-container');

  // Find the Shopify Forms root using stable attribute
  var formRoot = document.querySelector('[data-forms-id="forms-root-406547"]');

  // Get the parent Shopify section
  var hiddenSection = formRoot ? formRoot.closest('.shopify-section') : null;

  // Move section into modal (only once)
  if (hiddenSection && container && !container.contains(hiddenSection)) {
    container.appendChild(hiddenSection);
    hiddenSection.style.display = 'block';
  }

  trigger.addEventListener('click', function (e) {
    e.preventDefault();
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  });

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);
});
